export class EngubatorMovementType {
    id: number;
    name: string;
}